module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10239.1b6e74b3.jpg";